import { SpinRequestBuilder } from "ags/integration/builders/requests/spin-request-builder";
import gameiomModel from "gameiom/model/gameiom-model";
import Gameplay from "slotworks/model/gameplay/gameplay";
import FreespinRequestPayload from "slotworks/model/gameplay/requests/freespin-request-payload";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import { SocketRequest } from "slotworks/server/connectors/socket-connector";

class FreespinRequestBuilder implements RequestBuilder {
    public filter(request: any): boolean {
        return request instanceof FreespinRequestPayload;
    }
    public build(gameplay: Gameplay, request: any) {

        let force: string | number[] = SpinRequestBuilder.force;

        if (force && typeof force === "string") {
            if (force.indexOf(",") > -1) {
                force = force.split(",").map((v) => parseInt(v));
            } else if (force.indexOf(" ") > -1) {
                force = force.split(" ").map((v) => parseInt(v));
            }
        }

        SpinRequestBuilder.force = null;

        const body = {
            publicState: {
                action: "freespin",
                gameId: gameiomModel.gameId,
                force
            }
        };

        if (body.publicState.force === null) {
            delete body.publicState.force;
        }

        return new SocketRequest(body, gameiomModel.url);
    }
}

export default new FreespinRequestBuilder();
